export default __webpack_public_path__ + "static/media/f1.b7d3f6ee.jpg";